module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlack.6d672c07.woff2";